import PropTypes from 'prop-types'

import { pressable } from '@aytm/app/stats/components/lib/pressable'

import style from '@aytm/app/stats/page/question-views/components/charts/highcharts/components/zoom/styles/Zoom.module.scss'

// Presentational zoom toggle; state flags come from useZoom. DOM mirrors the
// legacy coffee .zoom-level-selector: container + two icons switched by .max.
const Zoom = ({ isMax, isWarning, title, onToggle }) => (
  <div
    className={`${style.zoom}${isMax ? ` ${style.max}` : ''}${isWarning ? ` ${style.warning}` : ''}`}
    aria-label={title}
    title={title}
    {...pressable(onToggle)}
  >
    <i className="icon-aytmfd-zoom-in" />
    <i className="icon-aytmfd-zoom-out" />
  </div>
)

Zoom.propTypes = {
  isMax: PropTypes.bool,
  isWarning: PropTypes.bool,
  title: PropTypes.string,
  onToggle: PropTypes.func
}

Zoom.displayName = 'Zoom'

export default Zoom
